module.exports = __webpack_public_path__ + "static/media/beatriz.ca9805d4.jpeg";